/**
 * @desc 广告模块
 */
const appModuleList = r => require.ensure([], () => r(require('../views/appModule/AppModuleList.vue')), 'appModuleList');

export default [
  //APP模块列表
  {
    name: 'appModuleList',
    path: '/appModuleList',
    component: appModuleList,
    meta: { title: 'APP模块列表' },
  },
]